/**
 * Description
 * ===========
 * This file is extreme, too many things are happening at once.
 * If you want to know anything about it, just ask me anytime
 * ~ erno
 */

import {
  makeStyles,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import clsx from 'clsx';
import { getGroupList, setCustomData } from "../../Shared/Actions/Actions";
import { setVisible } from '@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions';

import { fetchConfiguration } from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions";
import { withGlobalLoader } from "@configuratorware/configurator-frontendgui/App/Reducers/UI/Actions";
import { extractInputFields } from "../../Helpers";
import { GroupInput } from "../../Helpers/extractInputFields";

import { t, translationExists, T } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import isEmpty from "lodash/isEmpty";
import { Visibility } from "@material-ui/icons";

const useStyles = makeStyles(
  (theme) => ({
    "@global": {
      "*": {
        WebkitTapHighlightColor: `rgba(255, 255, 255, 0)`,
      },
    },
    root: {},
    categoriesDialogButton: {
      position: "fixed",
      top: 100, // magic
      left: 32, // magic
      zIndex: 99,
      [theme.breakpoints.down("sm")]: {
        left: "50%",
        top: 130, // magic
        transform: "translateX(-50%)",
      },
      [theme.breakpoints.down("xs")]: {
        left: "50%",
        top: 80, // magic
        transform: "translateX(-50%)",
      },
      '@media (min-aspect-ratio: 13 / 9) and (min-height: 280px) and (max-width: 825px)': {
        display: 'none',
      },
    },
    dialogContent: {
      boxSizing: "border-box",
      [theme.breakpoints.up("sm")]: {
        minWidth: 533,
      },
    },
    dialogContentWrapper: {
      boxSizing: "border-box",
      display: "flex",
      justifyContent: "center",
      gap: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    dialogPaper: {
      background: "#f5f5f5",
      boxShadow: "none",
    },
    dialogPaperFullScreen: {
      borderRadius: theme.shape.borderRadius,
      boxSizing: "border-box",
    },

    inputList: {
      boxSizing: "border-box",
      width: 280,
      display: "flex",
      gap: theme.spacing(2),
      flexDirection: "column",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      [theme.breakpoints.down("xs")]: {
        width: "auto",
      },
    },
    inputLine: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      "& > .wrapper": {
        flex: "0 0 100px",
        display: 'flex',
        alignItems: 'center',
      },
    },
    inputTitle: {
      [theme.breakpoints.down("xs")]: {
        fontSize: "0.75rem",
      },
    },
    input: {
      outline: "none",
      padding: "12px 16px",
      textAlign: "center",
      width: "100%",
      boxSizing: "border-box",
      border: `1px solid ${theme.palette.primary.main}`,
      fontFamily: theme.typography.fontFamily,
      borderRadius: "4px",
      backgroundColor: "#fff",
      [theme.breakpoints.down("xs")]: {
        padding: "8px 16px",
      },
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
      "&[type=number]": {
        MozAppearance: "textfield",
      },
    },
    groupButtonWrapper: {
      display: 'flex',
      alignItems: 'center'
    },
    buttonList: {
      boxSizing: "border-box",
      width: 280,
      display: "flex",
      gap: theme.spacing(2),
      flexDirection: "column",
      "&:only-child": {
        [theme.breakpoints.up("sm")]: {
          width: 340,
        },
      },
      [theme.breakpoints.up("sm")]: {
        minHeight: 300,
      },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      [theme.breakpoints.down("xs")]: {
        width: "auto",
      },
    },
    button: {
      fontWeight: 600,
      textTransform: "initial",
    },
    buttonLabel: {
      display: "block",
    },
    listTitle: {
      fontWeight: 600,
      marginBottom: theme.spacing(1),
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    dialogTitle: {
      fontSize: "1.75rem",
      fontWeight: 600,
      textTransform: "capitalize",
      [theme.breakpoints.down("xs")]: {
        fontSize: "1.25rem",
      },
    },
    infoLink: {
      paddingLeft: 8,
      fontWeight: 400,
      fontSize: ".75rem",
      cursor: "pointer",
      textDecoration: "underline",
      color: theme.palette.primary.main,
      transition: `color ${theme.transitions.duration.standard}ms`,
      visibility: 'hidden',
      "&.show": {
        visibility: 'visible'
      },
      "&:hover": {
        color: theme.palette.primary.dark,
      },
    },
  }),
  { name: "GroupedConfiguratorScreen" }
);

const fetchConfigurationWithLoader = (identifier) => (dispatch) =>
  dispatch(withGlobalLoader(fetchConfiguration(identifier)));

const showStartHere = () => (dispatch) => dispatch(setVisible('startHere', true));

const filterPriceBySize = (price, value) => {
  if (price.amountfrom <= value) return true;
  return false;
};

// Get the filtered price of the given element
const getPrice = (item, determinigValue) =>
  [...item?.prices]
    .sort((a, b) => b.amountfrom - a.amountfrom)
    .find((item) => filterPriceBySize(item, determinigValue))?.priceFormatted ||
  item.priceFormatted;

const arrayWithReferenceOrder = [
  "input_field_halsumfang",
  "input_field_halsausschnitt",
  "input_field_brustumfang",
  "input_field_bruststeg",
  "input_field_rueckensteg",
  "input_field_brustgurt",
  "input_field_rist",
];

function createItemsMap(itemsArray) {
  let itemsMap = {};
  for (let i = 0, item; (item = itemsArray[i]); ++i) {
    (itemsMap[item.key] = []).push(item);
  }
  return itemsMap;
}

function sortByKeys(itemsArray, sortingArr) {
  let itemsMap = createItemsMap(itemsArray),
    result = [];

  for (let i = 0; i < sortingArr.length; ++i) {
    const key = sortingArr[i];

    if (itemsMap[key]) {
      result.push(itemsMap[key][0]);
    }
  }
  return result;
}

const GroupedConfiguratorScreen = ({ Component }) => {
  const params = useParams();
  const classes = useStyles({});
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const isXSmall = useMediaQuery("(max-width: 375px)");

  const {
    group,
    configuration,
    itemIdentifier,
    userValues = [],
    defaultSize = false,
  }: any = useSelector((state: any) => ({
    group: state.group,
    configuration: state.configurator.configuration,
    itemIdentifier: state.configurator.configuration.item?.identifier,
    userValues: state.configurator.configuration.customdata?.userValues,
    defaultSize: state.configurator.configuration.customdata?.defaultSize,
  }));

  // Check the the group or the selected item is part of the `vario` group
  const isVario = (): boolean => {
    return (
      params.group === "geschirr_vario" ||
      configuration.item.itemPoolIdentifier === "geschirr_vario"
    );
  };

  // Dialog status
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
  // Highlighted item in button list
  const [selectedConfigurationId, setSelectedConfigurationId] = useState("");
  // Filtered list by the `Determining input field`
  const [filteredGroup, setFilteredGroup] = useState([]);
  //InputFields gathered from group (as they come from API)
  const [inputFields, setInputFields] = useState<GroupInput[]>([]);
  // Values of the the previous input fields
  const [inputValues, setInputValues] = useState<
    { key: string; value: number | string; determining: boolean }[]
  >([]);
  // Vario related state
  const [isDefaultSize, setIsDefaultSize] = useState(isVario());

  // Mount
  useEffect(() => {
    if (params.group) {
      // The group related dialog would open automatically,
      // when the the app is in group mode
      setIsCategoriesOpen(true);
    }
  }, []);

  // == Vario related state setting ==
  // When the app is loaded by code or identifier,
  // `defaultSize` need to be set according the result configuration
  useEffect(() => {
    if (!params.group && defaultSize) {
      setIsDefaultSize(defaultSize);
    }
  }, [defaultSize]);

  // When another item has been chosen in group dialog...
  useEffect(() => {
    // ...and it's valid...
    if (configuration.item.identifier) {
      // ...then set it as selected for Button highlight
      setSelectedConfigurationId(configuration.item.identifier);
    }
  }, [configuration.item.identifier]);

  // Input fields has been loaded for the group...
  useEffect(() => {
    const selectedItem = group.list.find(
      (item) => item.identifier === selectedConfigurationId
    );

    setInputValues(
      inputFields.map((f) => ({
        key: f.key,
        value:
          isDefaultSize && selectedItem
            ? selectedItem.attributes.find((attr) => attr.identifier === f.key)
                .values[0].value
            : (!isEmpty(userValues) &&
                userValues.find((i) => i.key === f.key)?.value) ||
              "",
        determining: f.determining,
      }))
    );
  }, [inputFields]);

  // `filteredGroup` is updating when the group's
  // determining input field's value is changing
  useEffect(() => {
    setFilteredGroup(
      group.list.filter((item) => {
        let show = true;
        item.attributes
          .filter((attr) => attr.identifier.indexOf("input_field_") > -1)
          .forEach((attr) => {
            const findCondition = (i) => i.key === attr.identifier;
            const currentField = inputFields.find(findCondition);
            if (!currentField?.determining) return;
            const inputValue = inputValues.find(findCondition)?.value;
            const criteria = attr.values.filter(
              (i) => i.value !== "determining_field"
            )[0]?.value;
            const [min, max] = criteria.split("-");
            if (inputValue < parseInt(min) || inputValue > parseInt(max))
              show = false;
          });
        return show;
      })
    );
  }, [inputValues]);

  // After we got a valid lost of group items...
  useEffect(() => {
    /**
     * In group mode, the first item will be set as selected,
     * then call for it from the API
     */
    if (params.group && group.list.length > 0) {
      setSelectedConfigurationId(group.list[0].identifier);
      dispatch(fetchConfigurationWithLoader(group.list[0].identifier));
    }

    if (group.list.length > 0) {
      const fields = extractInputFields(group.list);
      const sorted = sortByKeys(fields, arrayWithReferenceOrder);

      fields.forEach((f) => {
        if (!arrayWithReferenceOrder.includes(f.key)) {
          sorted.push(f);
        }
      });

      setInputFields(sorted);
    }
  }, [group.list]);

  // If the `filteredGroup` length is not 0,
  // then the first item has to be the selected one in the dialog
  useEffect(() => {
    if (filteredGroup.length > 0) {
      setSelectedConfigurationId(filteredGroup[0].identifier);
    }
  }, [filteredGroup]);

  // Changing the state of the dialog
  useEffect(() => {
    // We have got no items from any group, so call for it
    if (isCategoriesOpen && group.list.length === 0) {
      dispatch(
        getGroupList(params.group || configuration.item.itemPoolIdentifier)
      );
    }
  }, [isCategoriesOpen]);

  useEffect(() => {
    /**
     * Add value to textfields accordin to selected item, if the defaulsSize is true
     * and inpoutValues already have some items
     */
    if (isVario() && isDefaultSize && inputValues.length) {
      const selectedItem = group.list.find(
        (item) => item.identifier === selectedConfigurationId
      );
      setInputValues([
        ...inputValues.map((val) => ({
          ...val,
          value: selectedItem?.attributes.find(
            (attr) => attr.identifier === val.key
          ).values[0].value,
        })),
      ]);
    }
  }, [selectedConfigurationId, isDefaultSize]);

  useEffect(() => {
    if (!isDefaultSize) {
      setInputValues(
        inputFields.map((f) => ({
          key: f.key,
          value: "",
          determining: f.determining,
        }))
      );
    }
  }, [isDefaultSize]);

  useEffect(() => {
    configuration?.customdata?.userValues?.length &&
      setInputValues(configuration.customdata.userValues);
  }, [configuration.code]);

  const onInputChange = (e, item) => {
    if (!isDefaultSize) {
      setInputValues([
        ...inputValues.map((val) =>
          val.key === item.key ? { ...val, value: e.target.value } : val
        ),
      ]);
    }
  };

  const handleItemOnClick = (item, e) => {
    setSelectedConfigurationId(item.identifier);
  };

  const handleOnLoadClick = async () => {
    // Close category dialog
    setIsCategoriesOpen(false);

    if (itemIdentifier !== selectedConfigurationId) {
      dispatch(showStartHere());
      await dispatch(fetchConfigurationWithLoader(selectedConfigurationId));
    }

    dispatch(
      setCustomData({
        userValues: isDefaultSize ? [] : inputValues,
        defaultSize: isDefaultSize,
      })
    );
  };

  // Validates the informations for continue
  const mainButtonValidate = () => {
    // Checks all input is filled with valid numbers
    for (const [key, item] of Object.entries(inputValues)) {
      if (!item.value) return false;
    }

    // Checks that the selectedConfigurationId is represented in the filtered list
    const buttonKeys = filteredGroupForRender.map((item) => item.identifier);
    if (!buttonKeys.includes(selectedConfigurationId)) return false;

    // If everything is fine...
    return true;
  };

  const hasValidConfiguration = !!configuration.item?.identifier;
  const filteredGroupForRender = isDefaultSize ? group.list : filteredGroup;

  const determinigValue =
    inputValues.find((item) => item.determining)?.value || 0;

  const handleInputFieldInfoLinkOnClick = (inputField) => {
    window.parent.postMessage(
      {
        method: "openInformationDialog",
        url: t(`custom.infoMessageUrl.${inputField}`),
      },
      "*"
    );
  };

  const handleItemInfoLinkOnClick = (url) => {
    window.parent.postMessage(
      {
        method: "openInformationDialog",
        url,
      },
      "*"
    );
  };

  /**
   * ===================
   *       RENDERS
   * ===================
   */

  const renderButtonList = () => {
    return (
      <div className={classes.buttonList}>
        <Typography className={classes.listTitle} variant="body1">
          <span>{t("custom.title.suitableBandwidths")}:</span>
        </Typography>
        {filteredGroupForRender.map((item, index, self) => {
          return (
            <div className={classes.groupButtonWrapper}>
              <Button
                key={item.identifier}
                className={classes.button}
                classes={{ label: classes.buttonLabel }}
                color="secondary"
                fullWidth
                onClick={(e) => handleItemOnClick(item, e)}
                variant={
                  item.identifier === selectedConfigurationId
                    ? "contained"
                    : "outlined"
                }
              >
                {item.title} ab{" "}
                <span style={{ display: "inline-block" }}>
                  {getPrice(item, determinigValue)}
                </span>
              </Button>
              <span className={clsx(classes.infoLink, item.abstract && item.abstract !== "" && 'show')} onClick={() => handleItemInfoLinkOnClick(item.abstract)}>
                {t("custom.infoLink.label")}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const hasUrl = (key) => {
    const translationKey = `custom.infoMessageUrl.${key}`
    const translatedText = t(translationKey);
    return translationExists(`custom.infoMessageUrl.${key}`) && translatedText !== '' && translatedText !== translationKey;
  }

  const renderInputList = () => (
    <div className={classes.inputList}>
      <Typography className={classes.listTitle} variant="body1">
        <span>{t("custom.title.dimensions")}:</span>{" "}
      </Typography>
      {inputFields.map((item) => {
        const value = inputValues.find((val) => val.key === item.key)?.value;

        return (
          <div className={classes.inputLine} key={item.key}>
            <div>
              <Typography className={classes.inputTitle} variant="body1">
                {item.title}
              </Typography>
            </div>
            <div className="wrapper">
              <input
                type={isDefaultSize ? "text" : "number"}
                readOnly={isDefaultSize}
                className={classes.input}
                value={value}
                onChange={(e) => onInputChange(e, item)}
              />
              <Typography component="span" className={clsx(classes.infoLink, hasUrl(item.key) && 'show')} onClick={() => handleInputFieldInfoLinkOnClick(item.key)}>
                {t("custom.infoLink.label")}
              </Typography>
            </div>
          </div>
        );
      })}
      {isVario() && (
        <Button
          variant="outlined"
          onClick={() => setIsDefaultSize(!isDefaultSize)}
        >
          {isDefaultSize
            ? t("custom.button.setCustomSize")
            : t("custom.button.setDefaultSize")}
        </Button>
      )}
    </div>
  );

  const dialogTitleText = t(
    `group.${params.group || configuration?.item.itemPoolIdentifier}`
  );

  return (
    <>
      <Button
        onClick={() => setIsCategoriesOpen(true)}
        variant="contained"
        color="secondary"
        size={isSmall ? "small" : "medium"}
        className={classes.categoriesDialogButton}
      >
        {t("custom.button.basicSettings")}
      </Button>

      <Dialog
        open={isCategoriesOpen}
        // onClose={() => setIsCategoriesOpen(false)}
        classes={{
          paper: classes.dialogPaper,
          paperFullScreen: classes.dialogPaperFullScreen,
        }}
        maxWidth={false}
        fullScreen={isXSmall ? true : false}
      >
        <DialogTitle>
          <Typography variant="h3" className={classes.dialogTitle}>
            {dialogTitleText}
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <div className={classes.dialogContentWrapper}>
            {inputFields.length > 0 && renderInputList()}
            {renderButtonList()}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleOnLoadClick}
            variant="contained"
            disabled={!mainButtonValidate()}
          >
            {t("custom.button.configurate")}
          </Button>
        </DialogActions>
      </Dialog>

      {hasValidConfiguration && Component}
    </>
  );
};

export default GroupedConfiguratorScreen;
